import { useCurrentClassStore } from '@/stores/useCurrentClassStore';
import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { getTenantScopedClassOrGroup } from '@/utils/schoolClass.utils';
import type { IWeekNumberSettings } from '@/utils/schoolYear.utils';
import { WeekRepresentation } from 'common/enum/user.setting.enum';
import { computed, ComputedRef } from 'vue';

// Store-backed like useDisplayName. Week views render inside the current class, so its school year anchors the
// school-week count; useCurrentClass() is avoided because it starts the school-classes query.
export function useWeekNumberSettings(): { weekNumberSettings: ComputedRef<IWeekNumberSettings> } {
  const whoAmIStore = useWhoAmIStore();
  const currentClassStore = useCurrentClassStore();

  const weekNumberSettings = computed<IWeekNumberSettings>(() => ({
    weekRepresentation: whoAmIStore.whoAmI?.weekRepresentation ?? WeekRepresentation.calendarWeek,
    schoolYear:
      getTenantScopedClassOrGroup(currentClassStore.currentClass, whoAmIStore.whoAmI?.currentTenantId)?.schoolYear ??
      null,
  }));

  return { weekNumberSettings };
}
